<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="授权到期时间" :prop="dialogData.isBatch ? '' : 'expire_at'">
        <date-picker v-model="form.expire_at" type="after"/>
      </el-form-item>
      <template v-if="!dialogData.row">
        <el-form-item label="XLSX文件" prop="xls_file">
          <upload-file v-model="form.xls_file" suffix="xlsx"/>
        </el-form-item>
        <el-form-item label="TAR文件" prop="zip_file">
          <upload-file v-model="form.zip_file" suffix="gz"/>
        </el-form-item>
        <el-form-item label="设备型号" prop="model">
          <el-input v-model.trim="form.model" clearable/>
        </el-form-item>
      </template>
      <el-form-item label="备注" prop="remark">
        <el-input v-model.trim="form.remark" clearable :maxlength="128"/>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import UploadFile from "@view/components/upload/UploadFile"
  import DatePicker from "@view/components/date/DatePicker"
  import {changeEmpty, inputEmpty} from "@utils/validate"
  export default {
    name: "ImportFormal",
    components: {UploadFile, DatePicker},
    props: {dialogData: Object},
    data() {
      return {
        form: {
          expire_at: "",
          xls_file: "",
          zip_file: "",
          model: "",
          remark: "",
        },
        rules: {
          expire_at: [changeEmpty("授权到期时间")],
          xls_file: [changeEmpty("XLSX文件")],
          zip_file: [changeEmpty("TAR文件")],
          model: [inputEmpty("设备型号")],
        },
      }
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.form).forEach(key => key in row && (this.form[key] = row[key]));
      }
    },
    methods: {
      confirm() {
        let row = this.dialogData.row;
        row ? this.revise(row) : this.add();
      },
      add() {
        this.$refs["form"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.form};
            let res = await this.$Http.importFormal(nv, {}, true);
            if (res?.data) {
              const success = res.data.success_cnt;
              this.openAlert(`导入完成，成功：${success} 个`, () => {
                this.$emit("table-reload");
                this.dialogData.visible = false;
              });
            }
          }
        });
      },
      revise(row) {
        this.$refs["form"].validate(isOk => {
          if (isOk) {
            this.openConfirm("修改该正式授权", async () => {
              const nv = {
                auth_prod_id: row.id,
                expire_at: this.form.expire_at,
                remark: this.form.remark,
              }
              !nv.expire_at && delete nv.expire_at;
              let res = await this.$Http.reviseFormal(nv);
              if (res) {
                this.msgSuccess("修改成功");
                this.$emit("table-reload");
                this.dialogData.visible = false;
              }
            });
          }
        });
      },
    }
  }
</script>

<style scoped>

</style>
